import { createAction } from "@reduxjs/toolkit";

import {
  assignFormActionTypes,
  createConsentFormActionTypes,
  deleteConsentFormActionTypes,
  editConsentFormNameActionTypes,
  getConsentFormsActionTypes,
  getNewSignConsentFormsCountActionTypes,
  getPortionConsentFormsActionTypes,
  getPortionReceivedFormsActionTypes,
  getReceivedFormsActionTypes,
  rejectReceivedFormActionTypes,
  setSigningConsentFormIdActionType,
  signReceivedFormActionTypes,
} from "./actionTypes";

export const createConsentForm = createAction(
  createConsentFormActionTypes.request,
  (payload) => ({ payload }),
);
export const createConsentFormSuccess = createAction(
  createConsentFormActionTypes.success,
  (payload) => ({ payload }),
);
export const createConsentFormFailure = createAction(
  createConsentFormActionTypes.failure,
  (payload) => ({ payload }),
);

export const getConsentForms = createAction(
  getConsentFormsActionTypes.request,
  (payload) => ({ payload }),
);
export const getConsentFormsSuccess = createAction(
  getConsentFormsActionTypes.success,
  (payload) => ({ payload }),
);
export const getConsentFormsFailure = createAction(
  getConsentFormsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getPortionConsentForms = createAction(
  getPortionConsentFormsActionTypes.request,
  (payload) => ({ payload }),
);
export const getPortionConsentFormsSuccess = createAction(
  getPortionConsentFormsActionTypes.success,
  (payload) => ({ payload }),
);
export const getPortionConsentFormsFailure = createAction(
  getPortionConsentFormsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getReceivedForms = createAction(
  getReceivedFormsActionTypes.request,
  (payload) => ({ payload }),
);
export const getReceivedFormsSuccess = createAction(
  getReceivedFormsActionTypes.success,
  (payload) => ({ payload }),
);
export const getReceivedFormsFailure = createAction(
  getReceivedFormsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getPortionReceivedForms = createAction(
  getPortionReceivedFormsActionTypes.request,
  (payload) => ({ payload }),
);
export const getPortionReceivedFormsSuccess = createAction(
  getPortionReceivedFormsActionTypes.success,
  (payload) => ({ payload }),
);
export const getPortionReceivedFormsFailure = createAction(
  getPortionReceivedFormsActionTypes.failure,
  (payload) => ({ payload }),
);

export const deleteConsentForm = createAction(
  deleteConsentFormActionTypes.request,
  (payload) => ({ payload }),
);
export const deleteConsentFormSuccess = createAction(
  deleteConsentFormActionTypes.success,
  (payload) => ({ payload }),
);
export const deleteConsentFormFailure = createAction(
  deleteConsentFormActionTypes.failure,
  (payload) => ({ payload }),
);

export const editConsentFormName = createAction(
  editConsentFormNameActionTypes.request,
  (payload) => ({ payload }),
);
export const editConsentFormNameSuccess = createAction(
  editConsentFormNameActionTypes.success,
  (payload) => ({ payload }),
);
export const editConsentFormNameFailure = createAction(
  editConsentFormNameActionTypes.failure,
  (payload) => ({ payload }),
);

export const signReceivedFormSuccess = createAction(
  signReceivedFormActionTypes.success,
  (payload) => ({ payload }),
);
export const signReceivedFormFailure = createAction(
  signReceivedFormActionTypes.failure,
  (payload) => ({ payload }),
);

export const rejectReceivedForm = createAction(
  rejectReceivedFormActionTypes.request,
  (payload) => ({ payload }),
);

export const rejectReceivedFormSuccess = createAction(
  rejectReceivedFormActionTypes.success,
  (payload) => ({ payload }),
);
export const rejectReceivedFormFailure = createAction(
  rejectReceivedFormActionTypes.failure,
  (payload) => ({ payload }),
);

export const assignForm = createAction(
  assignFormActionTypes.request,
  (payload) => ({ payload }),
);
export const assignFormSuccess = createAction(
  assignFormActionTypes.failure,
  (payload) => ({ payload }),
);
export const assignFormFailure = createAction(
  assignFormActionTypes.failure,
  (payload) => ({ payload }),
);

export const getNewSignConsentFormsCount = createAction(
  getNewSignConsentFormsCountActionTypes.request,
  (payload) => ({ payload }),
);
export const getNewSignConsentFormsCountSuccess = createAction(
  getNewSignConsentFormsCountActionTypes.success,
  (payload) => ({ payload }),
);
export const getNewSignConsentFormsCountFailure = createAction(
  getNewSignConsentFormsCountActionTypes.failure,
  (payload) => ({ payload }),
);

export const setSigningConsentFormId = createAction(
  setSigningConsentFormIdActionType,
  (payload) => ({ payload }),
);
